import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../calendar/Calendar.js';
import ChartHistory_Production from '../chart/ChartHistory_Production';

import ModalLoad from '../modal/ModalLoad';
import ModalPopupMessage from '../modal/ModalPopupMessage';

function HistoricalDataProduction(props) {
    const [reportsite, setReportsite] = useState('-');

    const [reporttype_picker, setReporttype_picker] = useState('day');
    const [reporttype, setReporttype] = useState('daily-5m');
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));
    const [calendar_text, setCalendar_text] = useState('Date');

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        return () => {
            setChart_plot({})
        };
    }, []);

    useEffect(() => {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.sitescope_arr !== null && props.permitdata.sitescope_arr !== undefined) {
                setReportsite(props.permitdata.sitescope_arr[0].sitecode_txt)
            }
        }
    }, [props.permitdata]);

    useEffect(() => {
        if (reporttype !== undefined) {
            if (reporttype === "daily-5m" || reporttype === "daily-h") {
                setReporttype_picker("date")
                setCalendar_text("Date")
            } else if (reporttype === "monthly") {
                setReporttype_picker("month")
                setCalendar_text("Month")
            } else if (reporttype === "yearly") {
                setReporttype_picker("year")
                setCalendar_text("Year")
            } else if (reporttype === "cod") {
                setReporttype_picker("month")
            }
        }
    }, [reporttype]);

    function disabledCalendar(current) {
        if (reporttype === "daily-5m" || reporttype === "daily-h") {
            return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
        } else if (reporttype === "monthly") {
            return current.isBefore(props.permitdata.cod_date, 'month') || current.isAfter(dayjs(new Date()).subtract(1, 'days').format("YYYY-MM-DD 23:59:59"), 'month')
        } else if (reporttype === "yearly") {
            return current.isBefore(props.permitdata.cod_date, 'year') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'year')
        }
    }

    const [chart_plot, setChart_plot] = useState({
        FileName: '',
        CSV_Data: [],
        XLabel: '',
        Sitename: '-',
        EnergyAC: [],
        EnergyGrid: [],
        ENS: [],
        IRR: [],
        errorx: [],
        CODData: null,
        Chart1_Style: {
            irr_type: "line",
            solar_type: "area",
            irr_unit: "w/m2",
            solar_unit: "kW",
            grid_unit: "kW",
            ens_unit: "kW",
            axis_y1: 'Power (kW)',
            axis_y2: 'Irradiation (W/m2)',
            solar_tag: 'Solar Power',
            grid_tag: 'Grid Power',
            ens_tag: 'Energy not Supply (P)',
            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
        },
    });

    async function api_query() {
        let dt = ""
        if (reporttype === "daily-5m") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD") + " 00:00:00"
        } else if (reporttype === "daily-h") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD") + " 00:00:00"
        } else if (reporttype === "monthly") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM") + "-01 00:00:00"
        } else if (reporttype === "yearly") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY") + "-01-01 00:00:00"
        } else if (reporttype === "cod") {
            dt = dayjs(new Date(reportdate_dt)).format("YYYY") + "-01-01 00:00:00"
        }

        setmodal_load({ enable: true, message: "Query historical production." })
        await sleep(500)

        const formData = new FormData();
        formData.append('post_url', "/proxy/center/api/historical/production")
        formData.append('token', props.permitdata.token)
        
        if (props.permitdata.view_mode === "local") {
            formData.append('reportsite', props.permitdata.sitecode)
        } else {
            formData.append('reportsite', reportsite)
        }
        formData.append('reporttype', reporttype)
        formData.append('reportdate', dt)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/production", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    let daplot = {
                        XLabel: response.data.plot.XLabel,
                        Sitename: response.data.sitename,
                        EnergyAC: [],
                        EnergyGrid: [],
                        ENS: [],
                        IRR: [],
                        errorx: [],
                        CODData: null,
                        Chart1_Style: {},
                        Chart2_Style: {},
                    }

                    if (reporttype === "daily-5m") {
                        daplot.Chart1_Style = {
                            irr_type: "line",
                            solar_type: "area",
                            irr_unit: "w/m2",
                            solar_unit: "kW",
                            grid_unit: "kW",
                            ens_unit: "kW",
                            axis_y1: 'Power (kW)',
                            axis_y2: 'Irradiation (W/m2)',
                            solar_tag: 'Solar Power',
                            grid_tag: 'Grid Power',
                            ens_tag: 'Energy not Supply (P)',
                            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
                        }
                        daplot.CODData = null
                    } else if (reporttype === "daily-h") {
                        daplot.Chart1_Style = {
                            irr_type: "line",
                            solar_type: "column",
                            irr_unit: "wh/m2",
                            solar_unit: "kWh",
                            grid_unit: "kWh",
                            ens_unit: "kWh",
                            axis_y1: 'Energy (kWh)',
                            axis_y2: 'Irradiation (Wh/m2)',
                            solar_tag: 'Solar Energy',
                            grid_tag: 'Grid Energy',
                            ens_tag: 'Energy not Supply',
                            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical'
                        }
                        daplot.CODData = null
                    } else if (reporttype === "monthly") {
                        daplot.Chart1_Style = {
                            irr_type: "line",
                            solar_type: "column",
                            irr_unit: "wh/m2",
                            solar_unit: "kWh",
                            grid_unit: "kWh",
                            ens_unit: "kWh",
                            axis_y1: 'Energy (KWh)',
                            axis_y2: 'Irradiation (Wh/m2)',
                            solar_tag: 'Solar Energy',
                            grid_tag: 'Grid Energy',
                            ens_tag: 'Energy not Supply',
                            xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical'
                        }
                        daplot.CODData = { CODIndex_Start: response.data.plot.CODData.CODIndex_Start, CODIndex_Stop: response.data.plot.CODData.CODIndex_Stop }
                    } else if (reporttype === "yearly") {
                        daplot.Chart1_Style = {
                            irr_type: "line",
                            solar_type: "column",
                            irr_unit: "wh/m2",
                            solar_unit: "MWh",
                            grid_unit: "MWh",
                            ens_unit: "MWh",
                            axis_y1: 'Energy (MWh)',
                            axis_y2: 'Irradiation (Wh/m2)',
                            solar_tag: 'Solar Energy',
                            grid_tag: 'Grid Energy',
                            ens_tag: 'Energy not Supply',
                            xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical'
                        }
                        daplot.CODData = { CODIndex_Start: response.data.plot.CODData.CODIndex_Start, CODIndex_Stop: response.data.plot.CODData.CODIndex_Stop }
                    } else if (reporttype === "cod") {
                        daplot.Chart1_Style = {
                            irr_type: "line",
                            solar_type: "column",
                            irr_unit: "wh/m2",
                            solar_unit: "MWh",
                            grid_unit: "MWh",
                            ens_unit: "MWh",
                            axis_y1: 'Energy (MWh)',
                            axis_y2: 'Irradiation (Wh/m2)',
                            solar_tag: 'Solar Energy',
                            grid_tag: 'Grid Energy',
                            ens_tag: 'Energy not Supply',
                            xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: ' YYYY', indexlabel: 'vertical'
                        }
                        daplot.CODData = null
                    }


                    let energy_col = "solar"
                    let grid_col = "grid"
                    if (reporttype === "daily-5m") {
                        energy_col = "solar_active"
                        grid_col = "grid_active"
                    }
                    for (let i = 0; i < response.data.plot.Data.length; i++) {
                        const dx = new Date(response.data.plot.Data[i].x)

                        daplot.IRR.push({ x: dx, y: response.data.plot.Data[i].irr })
                        daplot.EnergyAC.push({ x: dx, y: response.data.plot.Data[i][energy_col] })
                        daplot.EnergyGrid.push({ x: dx, y: response.data.plot.Data[i][grid_col] })
                        daplot.ENS.push({ x: dx, y: response.data.plot.Data[i]['ens'] })
                        daplot.errorx.push(response.data.plot.Data[i]['error'])
                    }

                    setChart_plot({
                        ...chart_plot,
                        FileName: response.data.plot.filename,
                        CSV_Data: response.data.plot.Data,
                        XLabel: daplot.XLabel,
                        Sitename: daplot.Sitename,
                        IRR: daplot.IRR,
                        EnergyAC: daplot.EnergyAC,
                        EnergyGrid: daplot.EnergyGrid,
                        ENS: daplot.ENS,
                        errorx: daplot.errorx,
                        CODData: daplot.CODData,
                        Chart1_Style: daplot.Chart1_Style,
                        Chart2_Style: daplot.Chart2_Style,
                    })
                }
                else {
                    reset_chart()
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                reset_chart()
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function export_csv() {
        let firstcol = 'Timestamp'
        let tableheader = [firstcol,
            'Solar Energy (' + chart_plot.Chart1_Style.solar_unit + ')',
            'Grid Energy (' + chart_plot.Chart1_Style.grid_unit + ')',
            'Energy not Supply (' + chart_plot.Chart1_Style.ens_unit + ')',
            'Irradiation (wh/m2)']

        if (reporttype === "daily-5m") {
            firstcol = 'Timestamp'
        } else if (reporttype === "daily-h") {
            firstcol = 'Hour'
        } else if (reporttype === "monthly") {
            firstcol = 'Date'
        } else if (reporttype === "yearly") {
            firstcol = 'Month'
        } else if (reporttype === "cod") {
            firstcol = 'Year'
        }

        let energy_col = "solar"
        let grid_col = "grid"
        if (reporttype === "daily-5m") {
            energy_col = "solar_active"
            grid_col = "grid_active"
        }

        const tableData = [];
        tableData.push(tableheader.join(","));
        for (const row of chart_plot.CSV_Data) {
            const rowData = [];
            if (row["date"] !== null) {
                if (row["date"] !== "-") {
                    if (row["date"] !== null) {
                        rowData.push(row["date"].replaceAll(",", ""))
                    } else { rowData.push('') }

                    if (row[energy_col] !== null) {
                        rowData.push(row[energy_col])
                    } else { rowData.push('') }

                    if (row[grid_col] !== null) {
                        rowData.push(row[grid_col])
                    } else { rowData.push('') }

                    if (row["ens"] !== null) {
                        rowData.push(row["ens"])
                    } else { rowData.push('') }

                    if (row["irr"] !== null) {
                        rowData.push(row["irr"])
                    } else { rowData.push('') }

                    tableData.push(rowData.join(","));
                }
            }
        }

        let data = tableData.join("\n");
        const a = document.createElement("a");
        a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
        var fnamey = 'Production_' + chart_plot.FileName + '.csv'
        a.setAttribute("download", fnamey);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    function reset_chart() {
        setChart_plot({
            FileName: '',
            CSV_Data: [],
            XLabel: '',
            Sitename: '-',
            EnergyAC: [],
            EnergyGrid: [],
            ENS: [],
            IRR: [],
            errorx: [],
            CODData: null,
            Chart1_Style: {
                irr_type: "line",
                solar_type: "area",
                irr_unit: "w/m2",
                solar_unit: "kW",
                grid_unit: "kW",
                ens_unit: "kW",
                axis_y1: 'Power (kW)',
                axis_y2: 'Irradiation (W/m2)',
                solar_tag: 'Solar Power',
                grid_tag: 'Grid Power',
                ens_tag: 'Energy not Supply',
                xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
            },
        })
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-table-search color-orange"></i> Production</h4>
                                    <p className="mb-0">Query your energy production solar, grid and irradiation</p>
                                </div>
                                {
                                    !props.iscenter ?
                                        <div>
                                            {BackCenter()}
                                        </div>
                                        : null
                                }
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        {
                            props.iscenter ?
                                <div className="d-block">
                                    <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                                    <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                        setReportsite(e.target.value)
                                    }} required>
                                        {
                                            props.permitdata !== null ?
                                                props.permitdata.sitescope_arr.map((data, index) => (
                                                    <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                ))
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Type</label>
                            <select id="reporttype" name="reporttype" className="form-select" value={reporttype} onChange={(e) => {
                                setReporttype(e.target.value)
                            }} required>
                                <option value="daily-5m">Daily-5m</option>
                                <option value="daily-h">Daily-h</option>
                                <option value="monthly">Monthly</option>
                                <option value="yearly">Yearly</option>
                                <option value="cod">From COD</option>
                            </select>
                        </div>
                        <div className={reporttype !== "cod" ? "d-block " : "d-none"} style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select {calendar_text}</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                picker={reporttype_picker}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                            <div className="d-block align-self-end print-disable">
                                <div className="d-flex gap-1 mt-3 mt-lg-0" style={{ marginBottom: "3px" }}>
                                    <button className="btn btn-secondary btn-sm " onClick={() => { export_csv() }}><i className="fas fa-file-csv "></i> Export CSV</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Energy Production Chart</h5>
                                    <div className='query-info-table mt-0'>
                                        <div className='query-info-row'>
                                            <div className='query-info-cell info-name'>Site Name</div>
                                            <div className='query-info-cell'>{chart_plot.Sitename}</div>
                                        </div>
                                    </div>
                                    <ChartHistory_Production
                                        solorpower={chart_plot.EnergyAC}
                                        gridpower={chart_plot.EnergyGrid}
                                        enspower={chart_plot.ENS}
                                        irr={chart_plot.IRR}
                                        xlabel={chart_plot.XLabel}
                                        chart_style={chart_plot.Chart1_Style}
                                        cod={chart_plot.CODData}
                                        error={chart_plot.errorx}
                                    ></ChartHistory_Production>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default HistoricalDataProduction